module.exports = __webpack_public_path__ + "img/icon-sad.22a51559.svg";